import React, { useEffect, useState } from "react";
import DecorativeSquares from "../../components/ui/DecorativeSquares";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Checkbox, Select, TextInput } from "../../components/form/inputs";
import InputBase from "../../components/form/inputs/InputBase";
import { useDispatch, useSelector } from "react-redux";
import { getCustomerRecords } from "../../redux/thunks/customerRecordThunk";
import { getCustomerMealPlan } from "../../redux/thunks/deiverAnorderThunk";
import { getMealDetailById } from "../../redux/thunks/mealsetupThunk";
import PrimaryBtn from "../../components/button/PrimaryBtn";
import { saveSubsOrderDraft } from "../../redux/slices/SubscriptionDraftSlice";
import EditSubscShimmer from "../../components/Preloader/EditSubscShimmer";
import { FaArrowLeft } from "react-icons/fa";
import { decryptId, encryptId } from "../../utils/urlCrypto";

const EditSubscriptionplan = () => {
  const navigate = useNavigate();
  const { meal_plan_id: paramMealPlanId } = useParams();
  const meal_plan_id = decryptId(paramMealPlanId);
  const location = useLocation();
  const dispatch = useDispatch();
  const { isCustmerLoading } = useSelector((state) => state.customerRecords);
  const { isPlanLoading } = useSelector((state) => state.planSlice);
  const customer_id = location.state?.customerId;
  const [planType, setPlanType] = useState("");
  const [orderCount, setOrderCount] = useState(0);
  // This is the meal plan id which is for weekly and monthly plan
  const [MealId, setMealId] = useState();
  const [startDate, setStartDate] = useState("");
  const [mealTiming, setMealTiming] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [customerNumber, setCustomerNumber] = useState("");
  const [customerAddress, setCustomerAddress] = useState("");
  const [extras, setExtras] = useState([]);
  const [mealName, setMealName] = useState("");
  const [mealImage, setMealImage] = useState(null);
  const [mealAmt, setMealAmt] = useState("");
  const [mealQuantity, setMealQuantity] = useState();
  const [planId, setPlanId] = useState(null);
  const [planAmount, setPlanAmount] = useState(null);
  const [deliveryDays, setDeliveryDays] = useState([]);
  const [AmtPrOrder, setAmtPrOrder] = useState("");
  const [deliveryType, setDeliveryType] = useState("");
  const [deliveryCharge, setDeliveryCharge] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [cInitials, setCInitials] = useState("");
  const [AddressId, setAddressId] = useState(null);
  const [SubscriptionCost, setSubscriptionCost] = useState(0);
  const [resetDiscount, setResetDiscount] = useState(false);
  const [apiPerOrderAmt, setApiPerOrderAmt] = useState(0);
  const [hasUserChanged, setHasUserChanged] = useState(false);
  const [Curr, setCurr] = useState("");

  const WEEK_DAYS = [
    { id: 1, label: "M", name: "Monday" },
    { id: 2, label: "Tu", name: "Tuesday" },
    { id: 3, label: "W", name: "Wednesday" },
    { id: 4, label: "Th", name: "Thursday" },
    { id: 5, label: "F", name: "Friday" },
    { id: 6, label: "Sa", name: "Saturday" },
    { id: 7, label: "Su", name: "Sunday" },
  ];

  // API logic goes here
  const getCustomer = () => {
    const payload = {
      service_provider_customer_id: customer_id,
    };

    dispatch(getCustomerRecords(payload))
      .unwrap()
      .then((res) => {
        // console.log("The res of getting customer details is :", res.data);
        const getName = res.data?.customer_name;
        setCustomerName(getName);

        const getCode = res.data?.country_code;
        setCountryCode(getCode);

        const getNumber = res.data?.contact_no;
        setCustomerNumber(getNumber);

        const getAddress = res.data?.default_address?.address_1;
        setCustomerAddress(getAddress);

        const getAddressId = res.data?.default_address?.address_id;
        setAddressId(getAddressId);

        const getInitials = res.data?.initials;
        setCInitials(getInitials);

        const getCurrency = res.data?.currency_symbol;
        setCurr(getCurrency);
      });
  };

  useEffect(() => {
    getCustomer();
  }, [customer_id]);

  // Get all meal plan details first

  const getMealPlanDetails = () => {
    const payload = {
      sp_customer_meal_plan_id: Number(meal_plan_id),
    };
    // console.log("The customer meal plan id is :", payload);

    dispatch(getCustomerMealPlan(payload))
      .unwrap()
      .then((res) => {
        // console.log(
        //   "The res of getting customer meal plan record from component is :",
        //   res.data,
        // );

        const getmealName = res.data?.meal?.meal_name;
        setMealName(getmealName);

        const getMealImg = res.data?.meal?.meal_image;
        setMealImage(getMealImg);

        const getMealAmt = res.data?.single_order_base_amounts;
        setMealAmt(getMealAmt);

        const getMealQuantity = res.data?.single_order_meal_quantity;
        setMealQuantity(getMealQuantity);

        const getExtra =
          res.data?.extra_items?.map((item) => ({
            id: item.meal_extra_item_id,
            name: item.name,
            price: Number(item.per_item_amount ?? 0),
            quantity: Number(item.quantity ?? 1),
          })) || [];

        setExtras(getExtra);

        const getPlanType = res.data?.plan_type;
        setPlanType(getPlanType);

        const getPlanId = res.data?.meal_plan_id;
        // console.log("The plan id is :", getPlanId);
        setPlanId(getPlanId);

        const getOrderCount = res.data?.order_count;
        setOrderCount(getOrderCount);

        const getmealId = res.data?.meal?.meal_id;
        setMealId(getmealId);

        const getDate = res.data?.start_date;
        setStartDate(getDate);

        const getTiming = res.data?.meal_timing;
        setMealTiming(getTiming);

        const getDeliveryDays = res.data?.delivery_days || [];
        setDeliveryDays(getDeliveryDays);
        const isHome = res.data?.is_home_delivery;
        const preference = res.data?.delivery_preference;

        // backend safe handling
        if (preference === "delivery") {
          setDeliveryType("delivery");
        } else {
          setDeliveryType("pickup");
        }

        // base meal amount
        setMealAmt(Number(res.data?.single_order_base_amounts ?? 0));

        // base delivery charge from backend
        setDeliveryCharge(Number(res.data?.single_order_delivery_charges ?? 0));

        // discount
        const rawDiscount = Number(
          res.data?.single_order_discount_and_other_charges ?? 0,
        );

        setDiscountAmount(rawDiscount);

        const getSubscriptionCost = res.data?.total_amount;
        setSubscriptionCost(getSubscriptionCost);

        const getFinalPerOrder = Number(
          res.data?.single_order_final_amounts ?? 0,
        );

        setApiPerOrderAmt(getFinalPerOrder);
        setAmtPrOrder(getFinalPerOrder); // 👈 initial value EXACT API
      });
  };
  useEffect(() => {
    if (deliveryType === "pickup") {
      setDeliveryCharge(0);
    }
  }, [deliveryType]);

  const extrasTotal = extras.reduce(
    (total, item) => total + Number(item.price) * Number(item.quantity),
    0,
  );

  const mealTotal = Number(mealAmt || 0) * Number(mealQuantity || 1);
  useEffect(() => {
    if (resetDiscount) {
      setDiscountAmount(0);
      setResetDiscount(false);
    }
  }, [resetDiscount]);
  useEffect(() => {
    if (!hasUserChanged) return;

    const deliveryAmt =
      deliveryType === "delivery" ? Number(deliveryCharge || 0) : 0;

    const finalAmount =
      mealTotal + extrasTotal + deliveryAmt + Number(discountAmount || 0); // 👈 PLUS hi rahega

    setAmtPrOrder(Number(finalAmount.toFixed(2)));
  }, [
    mealTotal,
    extrasTotal,
    deliveryType,
    deliveryCharge,
    discountAmount,
    hasUserChanged,
  ]);

  useEffect(() => {
    const total = Number(AmtPrOrder || 0) * Number(orderCount || 0);

    setSubscriptionCost(Number(total.toFixed(2)));
  }, [AmtPrOrder, orderCount]);

  useEffect(() => {
    getMealPlanDetails();
  }, [dispatch]);

  const isDiscount = discountAmount < 0;
  const absAmount = Math.abs(discountAmount);

  useEffect(() => {
    const payload = { meal_id: MealId };
    // console.log("The payload is :", payload);
    dispatch(getMealDetailById(payload))
      .unwrap()
      .then((res) => {
        const data = res.data;
        // console.log("Thr res is :", data);
        let selectedPlan = null;

        if (planType === "weekly") {
          selectedPlan = data.weekly_plans?.find(
            (p) => Number(p.id) === planId,
          );
        }

        if (planType === "monthly") {
          selectedPlan = data.monthly_plans?.find(
            (p) => Number(p.id) === planId,
          );
        }

        if (selectedPlan) {
          setPlanAmount(Number(selectedPlan.plan_amount));
        }
      });
  }, [MealId, planId, planType, dispatch]);

  const onMealQuantityInc = () => {
    setMealQuantity((prev) => prev + 1);
    setResetDiscount(true);
    setHasUserChanged(true);
  };

  const onMealQuantityDec = () => {
    setMealQuantity((prev) => (prev > 1 ? prev - 1 : 1));
    setResetDiscount(true);
    setHasUserChanged(true);
  };

  const toggleDeliveryDay = (dayId) => {
    setDeliveryDays(
      (prev) =>
        prev.includes(dayId)
          ? prev.filter((d) => d !== dayId) // unselect
          : [...prev, dayId], // select
    );
  };

  const saveDraftData = {
    customer: {
      cMealPlanId: meal_plan_id,
      id: customer_id,
      name: customerName,
      cCode: countryCode,
      number: customerNumber,
      address: customerAddress,
      spAddressId: AddressId,
      intials: cInitials,
    },
    meal: {
      meal_id: MealId,
      mName: mealName,
      mQty: mealQuantity,
      mAmt: mealAmt,
      mExtra: extras,
      mImage: mealImage,
      planId: planId,
      orderCounts: orderCount,
    },
    charges: {
      discount: discountAmount,
      deliverCharges: deliveryCharge,
      perOrderAmt: AmtPrOrder,
      subscriptCost: SubscriptionCost,
      extrasTotal: extrasTotal,
    },
    plan: {
      pType: planType,
      orderCounte: orderCount,
      startingDate: startDate,
      mTiming: mealTiming,
      deliDays: deliveryDays,
      deliType: deliveryType,
    },
  };

  const handleOnContinue = (meal_id) => {
    // console.log("The data saved in draft is :", saveDraftData);
    dispatch(saveSubsOrderDraft(saveDraftData));
    navigate(`/subscription-order-summery/${encryptId(meal_id)}`);
  };

  if (isPlanLoading && isCustmerLoading) return <EditSubscShimmer />;
  return (
    <>
      <section className="relative max-w-7xl mx-auto px-4 py-6 max-h-screen">
        <DecorativeSquares />
        <div className="sticky top-2 z-10 bg-white/80 backdrop-blur-md rounded-2xl shadow-md px-4 py-3 flex items-center justify-between mb-6">
          <button
            onClick={() => navigate(`/subscription/${encryptId(customer_id)}`)}
            className="flex items-center p-2 rounded-full hover:bg-gray-100"
          >
            <FaArrowLeft size={20} />
          </button>

          <h1 className="mx-auto text-2xl font-semibold text-gray-900">
            Edit Subscription
          </h1>
        </div>
        <div className="mx-auto max-w-7xl">
          <div className="bg-white rounded-md p-6 shadow-md">
            <div className="space-y-6">
              <TextInput
                label="Customer"
                disabled
                value={`${customerName} ${" "} +${countryCode} ${customerNumber} `}
              />
              <p className="text-black text-start">Meal</p>
              <div className="flex items-center gap-4 bg-gray-100 border border-gray-200 p-4 rounded-xl">
                {/* Avatar */}
                <div className="flex items-center justify-center   rounded-md bg-[#FFEFEB] text-[#FF6943] font-semibold">
                  <img
                    src={mealImage}
                    alt="dishImg"
                    className="object-cover w-12 h-12 rounded-md"
                  />
                </div>

                {/* User Info */}
                <div className="flex flex-col">
                  <h2 className="text-base font-semibold text-gray-900">
                    {mealName}
                  </h2>

                  <p className="mt-1 flex items-center gap-2 text-sm text-[#FF6943] font-bold">
                    {Curr}
                    {Number(mealAmt || 0).toFixed(2)} / meal
                  </p>
                </div>
              </div>
              <p>Quantity</p>
              <div className="flex items-center gap-3 self-start sm:self-center">
                <button
                  onClick={onMealQuantityDec}
                  className="border border-gray-200 h-8 w-8 rounded-md bg-[#FF6943] flex items-center justify-center text-white"
                >
                  −
                </button>

                <span className="border border-gray-200 h-8 w-8 rounded-md bg-white flex items-center justify-center text-sm font-normal">
                  {mealQuantity}
                </span>

                <button
                  onClick={onMealQuantityInc}
                  className="border border-gray-200 h-8 w-8 rounded-md bg-[#FF6943] flex items-center justify-center text-white"
                >
                  +
                </button>
              </div>

              <div className="border border-gray-200 rounded-lg p-4 space-y-3 bg-white">
                <h4 className="text-sm font-semibold text-gray-700">
                  Extra Items
                </h4>

                {extras.length === 0 ? (
                  <p className="text-sm text-gray-400 italic">
                    No extra items added
                  </p>
                ) : (
                  extras.map((exItem, index) => (
                    <div
                      key={exItem.extra_item_id ?? index}
                      className="flex justify-between items-center border-b last:border-b-0 pb-3 last:pb-0"
                    >
                      {/* Left info */}
                      <div>
                        <p className="text-sm font-medium text-gray-800">
                          {exItem.name}
                        </p>
                        <p className="text-xs text-gray-500">
                          {Curr}
                          {exItem.price.toFixed(2)} each
                        </p>
                      </div>

                      {/* Right controls */}
                      <div className="flex items-center gap-4">
                        {/* Qty controls */}
                        <div className="flex items-center gap-2">
                          <button
                            onClick={() => {
                              setExtras((prev) =>
                                prev.map((it, i) =>
                                  i === index && it.quantity > 1
                                    ? { ...it, quantity: it.quantity - 1 }
                                    : it,
                                ),
                              );
                              setResetDiscount(true);
                              setHasUserChanged(true);
                            }}
                            className="h-7 w-7 flex items-center justify-center rounded-md bg-gray-100 hover:bg-gray-200 text-gray-700"
                          >
                            −
                          </button>

                          <span className="min-w-[28px] text-center text-sm font-medium">
                            {exItem.quantity}
                          </span>

                          <button
                            onClick={() => {
                              setExtras((prev) =>
                                prev.map((it, i) =>
                                  i === index
                                    ? { ...it, quantity: it.quantity + 1 }
                                    : it,
                                ),
                              );
                              setResetDiscount(true);
                              setHasUserChanged(true);
                            }}
                            className="h-7 w-7 flex items-center justify-center rounded-md bg-[#FF6943] text-white hover:opacity-90"
                          >
                            +
                          </button>
                        </div>

                        {/* Item total */}
                        <p className="text-sm font-semibold text-[#FF6943] min-w-[70px] text-right">
                          {Curr}
                          {(exItem.price * exItem.quantity).toFixed(2)}
                        </p>
                      </div>
                    </div>
                  ))
                )}
              </div>

              <div>
                <TextInput label="Plan Type" disabled value={planType} />
              </div>
              <div>
                <button className="w-full flex justify-between items-center rounded-xl border border-gray-200 bg-gray-100 px-4 py-3">
                  <div className="flex gap-3 items-center">
                    <div
                      className={`h-4 w-4 rounded-full border border-orange-500"`}
                    >
                      <div className="h-2 w-2 bg-orange-500 rounded-full m-auto mt-[3px]" />
                    </div>

                    <div className="text-left">
                      <p className="text-sm font-medium">{orderCount} Meals</p>
                      <p className="text-xs text-gray-500">
                        {Curr}
                        {Number(mealAmt).toFixed(2)} / Meal
                      </p>
                    </div>
                  </div>

                  <span className="text-orange-600 font-semibold">
                    {Curr}
                    {Number(planAmount).toFixed(2)}
                  </span>
                </button>
              </div>
              <div>
                <TextInput label="Start date" disabled value={startDate} />
              </div>
              <div>
                <div>
                  <TextInput label="Meal Timing" disabled value={mealTiming} />
                </div>
              </div>
              {planType === "monthly" && (
                <div>
                  <p className="text-sm text-gray-700 text-start">
                    Deliver Days
                  </p>
                  <div className="flex gap-2 justify-start mt-4 flex-wrap">
                    {WEEK_DAYS.map((day) => {
                      const isSelected = deliveryDays.includes(day.id);

                      return (
                        <button
                          key={day.id}
                          type="button"
                          onClick={() => toggleDeliveryDay(day.id)}
                          className={`text-sm flex justify-center items-center rounded-md w-8 h-8 
          ${
            isSelected
              ? "bg-[#FF6943] text-white"
              : "bg-gray-200 text-[#FF6943]"
          }`}
                        >
                          {day.label}
                        </button>
                      );
                    })}
                  </div>
                </div>
              )}
              <div>
                <p className="text-base text-gray-800 text-start">
                  Delivery Type
                </p>
                <div className="flex gap-3 flex-wrap mt-4">
                  <Checkbox
                    variant="radio"
                    label="Home delivery"
                    name="deliveryType"
                    checked={deliveryType === "delivery"}
                    onChange={() => {
                      setDeliveryType("delivery");
                      setHasUserChanged(true);
                    }}
                  />

                  <Checkbox
                    variant="radio"
                    label="Pickup"
                    name="deliveryType"
                    checked={deliveryType === "pickup"}
                    onChange={() => {
                      setDeliveryType("pickup");
                      setHasUserChanged(true);
                    }}
                  />
                </div>
              </div>
              {deliveryType === "delivery" &&
                (!customerAddress ? (
                  <button
                    onClick={() =>
                      navigate(`/customer/add-customers-address/${customer_id}`)
                    }
                    className="w-full flex items-center justify-center gap-2 text-sm font-medium text-[#FF6943] border border-dashed rounded-xl py-3 hover:bg-orange-50"
                  >
                    <span className="text-lg">＋</span> Add New Address
                  </button>
                ) : (
                  <InputBase
                    type="textarea"
                    rows={2}
                    disabled
                    value={customerAddress}
                    onChangeLocation={() => navigate(`/address/${customer_id}`)}
                    variant="location"
                  />
                ))}

              <div>
                <p>Per order Amount</p>
                <div className="relative shrink-0 w-full mt-2">
                  <span className="absolute inset-y-0 left-0 flex items-center px-3 text-red-500 bg-red-50 border border-r-0 border-red-200 rounded-l-md text-sm font-medium">
                    {Curr}
                  </span>

                  <input
                    type="text"
                    value={AmtPrOrder}
                    readOnly
                    className="
                    w-full
                    pl-10 pr-2 py-2
                    text-start text-sm
                    border border-red-200
                    rounded-md
                    outline-none
                    focus:ring-2 focus:ring-red-200
                    "
                  />
                </div>
                {discountAmount !== 0 &&
                  (isDiscount ? (
                    <p className="text-xs text-green-500 font-semibold mt-4">
                      Discount: -{Curr}
                      {absAmount}
                    </p>
                  ) : (
                    <p className="text-xs text-red-500 font-semibold mt-4">
                      Other Charges: +{Curr}
                      {absAmount}
                    </p>
                  ))}
              </div>
            </div>
            <div className="flex justify-end mt-4">
              <PrimaryBtn
                btnName="Continue"
                clickEvent={() => handleOnContinue(meal_plan_id)}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default EditSubscriptionplan;
